import { render, staticRenderFns } from "./motCanCliente.vue?vue&type=template&id=79441142&scoped=true&"
import script from "./motCanCliente.vue?vue&type=script&lang=js&"
export * from "./motCanCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79441142",
  null
  
)

export default component.exports